import React, { useEffect, useState, Fragment } from 'react'
import { useDispatch } from 'react-redux';
import { setToastMessage } from '../../reducers/common.reducer';
import { LoadingSpinner } from '../../components';
import reportService from '../../services/reportService';
import moment from 'moment';
import PurchasedReportModal from './components/PurchasedReportModal';
import { FaTrashAlt, FaEdit, FaAngleDown } from "react-icons/fa";
import expendArrow from '../../assets/icons/Expand Arrow.png';
import NoData from '../../components/NoData';
import { Tooltip } from '@mui/material';
import HeaderTitle from '../../components/HeaderTitle';
import { useWindowWidth } from '@react-hook/window-size';
import ReportByPurchasedMobile from './mobile/ReportByPurchasedMobile';
import CustomCalendarSVG from '../../components/CustomCalendarSVG';
import CustomSearchBtn from '../../components/CustomSearchBtn';
import CustomNoData from '../../components/CustomNoData';

const filterType = [
  { "value": 2, "label": "Mix" },
  { "value": 1, "label": "Single" }
]

const ReportByPurchased = () => {
  const dispatch = useDispatch();
  const onlyWidth = useWindowWidth();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [date, setDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [reportData, setReportData] = useState([]);
  const [type, setType] = useState('');
  const [editedData, setEditedData] = useState();
  const [filter, setFilter] = useState(filterType[0]);
  const [showData, setShowData] = useState([]);

  useEffect(() => {
    fetchData();
    //eslint-disable-next-line
  }, [])

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await reportService.reportByPurchased(date);

      if (response.status === 200) {
        const filteredData = response.data.data.filter(a => a.gamblingTypeId === filter.value);
        setReportData(response.data.data);
        setShowData(filteredData);
      }
    }
    catch (error) {
      console.log(error);
    }
    finally {
      setIsLoading(false);
    }
  }

  const handleOpen = (value, data) => {
    setType(value);
    const filteredData = reportData.find(a => a.gamblingPurchaseId === data.gamblingPurchaseId);
    setEditedData(filteredData);
    setOpen(true);
  }

  const handleSave = async (type, data) => {
    setSaveLoading(true);
    if (type === "edit") {
      try {
        const payload = {
          gamblingPurchaseId: data.gamblingPurchaseId,
          betAmount: parseInt(data.betAmount),
          isHome: data.isHome,
          isAway: data.isAway,
          isOver: data.isOver,
          isUnder: data.isUnder,
          remark: data.remark
        }
        const response = await reportService.updatePurchasedVoucher(payload);

        if (response.status === 200) {
          dispatch(setToastMessage({ type: "success", message: response.data.message }));
          setOpen(false);
          fetchData();
        }
        else {
          dispatch(setToastMessage({ type: "error", message: response.data.message }));
        }
      }
      catch (err) {
        console.log("error>>>", err.message)
      }
      finally {
        setSaveLoading(false);
      }
    }
    if (type === "delete") {
      try {
        const response = await reportService.deletePurchasedVoucher(parseInt(data.gamblingPurchaseId));

        if (response.status === 200) {
          dispatch(setToastMessage({ type: "success", message: response.data.message }));
          setOpen(false);
          fetchData();
        }
        else {
          dispatch(setToastMessage({ type: "error", message: response.data.message }));
        }
      }
      catch (err) {
        console.log("error", err)
      }
      finally {
        setSaveLoading(false);
      }
    }
  };

  const handleSelect = (v) => {
    setFilter(v);
    const filteredData = reportData.filter(a => a.gamblingTypeId === v.value);
    setShowData(filteredData);
  }

  const handleSearch = () => {
     fetchData();
  }

  return (
    <Fragment>
       <div className='my-1'>
         <HeaderTitle title={"Purchased Report"} width={onlyWidth}/>
      </div>
      <PurchasedReportModal 
      open={open} 
      setOpen={setOpen} 
      editedData={editedData} 
      type={type} 
      setEditedData={setEditedData} 
      handleSave={handleSave}
      saveLoading={saveLoading} 
      isMobile={onlyWidth <= 768}
      />
      <div className=''>
        <section className="flex justify-center customFontRoboto text-xs mt-3">
          <div className='w-full px-3'>
            <div className="flex flex-wrap justify-start">
              <div className='w-40 relative'>
              <input
                className="bg-customTitleColor dark:bg-custom_dark_primary2 dark:text-customWhite dark:border-custom_dark_primary text-gray-700 px-5 py-2 rounded-md border border-gray-200 shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-200 focus:border-gray-100 transition duration-300 ease-in-out w-full cursor-pointer font-semibold"
                type="date"
                value={date}
                onChange={e => setDate(e.target.value)}
              />
              <CustomCalendarSVG />
              </div>
              <div className="flex w-[150px] mx-2 rounded-sm bg-customTitleColor dark:bg-custom_dark_primary2 dark:text-customWhite dark:border-custom_dark_primary items-center">
                <div className='main-wrapper relative group'>
                  <div className="flex w-[150px] rounded-sm items-center bg-customTitleColor dark:bg-custom_dark_primary2 cursor-pointer">
                    <span className="flex justify-center items-center w-[90%] bg-customTitleColor dark:bg-custom_dark_primary2 font-semibold">
                      {filter?.label}
                    </span>
                    <FaAngleDown className="w-8 dark:text-customWhite text-customForeColor" />
                  </div>
                  <ul className='w-full absolute group-hover:block hidden  border px-5 py-2 bg-white dark:bg-custom_dark_primary2'>
                    {
                      filterType && filterType.map((v, i) => {
                        return (
                          <li key={i} className={`p-3 text-center border-b-2 ${i === filterType.length - 1 ? null : 'border-customFontGreen dark:border-customWhite'} text-customFontGreen dark:text-customWhite cursor-pointer`} onClick={() => handleSelect(v)}> {v.label} </li>
                        )
                      })
                    }
                  </ul>
                </div>
              </div>
              {/* <button 
              className="text-white px-10 mt-1 py-2 hover:bg-customForeColor rounded-sm bg-slate-900 mb-1 dark:bg-custom_dark_primary dark:text-customLightYellow dark:font-bold" 
              onClick={() => handleSearch()}>Search</button> */}
              <CustomSearchBtn handleSearch={handleSearch}/>
            </div>
          </div>
        </section> 
        {onlyWidth <= 768 ? 
        <ReportByPurchasedMobile isLoading={isLoading} showData={showData} filter={filter} handleOpen={handleOpen}/> :
          <div className="flex justify-center mt-4 px-3">
            <table className="w-full">
              <thead>
                <tr className="customFontDangrek text-sm h-14 bg-customTitleColor dark:bg-custom_dark_primary2 dark:text-customWhite">
                  <th className='w-9' >{'No'}</th>
                  <th className='w-40' >{'CreatedAt'}</th>
                  {filter.value === 1 ? <th className='w-40' >Event Time</th> : null}
                  <th className='w-56 text-center' >{filter.value === 1 ? 'Event' : 'Voucher'}</th>
                  <th className='w-48'>
                    {filter.value === 1 ?
                      <>
                        <p>Choice</p>
                        <p className='text-[0.75rem]'>(Buy)</p>
                      </>
                      :
                      'Team Count'}
                  </th>
                  {/* <th className='w-20'>
                  <p>Amount</p>
                  <p className='text-[0.75rem]'>(Sell)</p>
                </th> */}
                  <th className='w-20'>
                    <p>Amount</p>
                    <p className='text-[0.75rem]'>(Buy)</p>
                  </th>
                  <th className='w-52 text-start' >{'Remark'}</th>
                  <th className='w-40'>{'Action'}</th>
                </tr>
              </thead>
              <tbody>
                {
                  isLoading ? <LoadingSpinner /> :
                    showData.length > 0 ?
                      showData.map((el, i) => (
                        <tr className="customFontRoboto text-[0.85rem] h-12 border-b-2 border-customTitleColor font-semibold dark:text-customWhite" key={i}>
                          <td className="text-center px-2">
                            <p>{i + 1}</p>
                          </td>
                          <td className="text-center px-2">
                            <p>{moment(el.createdAt).format("DD-MM-YYYY hh:mm A")}</p>
                          </td>
                          {
                            filter.value === 1 ? <td className='text-center px-2'>
                              <p>{moment(el.eventTime, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY")}</p>
                              <p>{moment(el.eventTime, "YYYY-MM-DD HH:mm:ss").format("hh:mm A")}</p>
                            </td> : null
                          }
                          <td className="text-center px-2 font-semibold">
                            {el.gamblingTypeId === 1 ?
                              <div className='flex flex-col'>
                                <p className='text-[0.68rem]'>{el.leagueName}</p>
                                <span className='text-customFontLightGreen'>{el.homeTeam} vs {el.awayTeam} </span>
                              </div>
                              : <span className='text-yellow-600'>{el.voucherNo}</span>
                            }
                          </td>
                          <td className="text-center px-2">
                            {
                              filter.value === 1 ?
                                <span className='text-yellow-600 font-semibold'>{el.isHome ? el.homeTeam : el.isAway ? el.awayTeam : el.isOver ? 'Over' : ' Under'}</span>
                                : <span>{el.teamCount}</span>
                            }
                          </td>
                          {/* <td className="text-center px-2">
                        {el.betAmount.toLocaleString('en-us')}
                      </td> */}
                          <td className="text-center px-2">
                            {el.betAmount.toLocaleString('en-us')}
                          </td>
                          <td className='text-start px-2'>
                            {el.remark}
                          </td>
                          <td className="flex justify-center items-center h-16">
                            <div className="flex justify-evenly items-center w-[60%] cursor-pointer" >
                              <Tooltip title="Edit" placement="top" arrow>
                                <span onClick={() => handleOpen('edit', el)}>
                                  <FaEdit className="text-customFontGreen text-lg" />
                                </span>
                              </Tooltip>
                              <Tooltip title="Delete" placement="top" arrow>
                                <span onClick={() => handleOpen('delete', el)}>
                                  <FaTrashAlt className="ml-1 text-customFontRed text-lg" />
                                </span>
                              </Tooltip>
                            </div>
                          </td>
                        </tr>
                      )) :
                      <tr>
                        <td colSpan={filter.value === 2 ? 7 : 8}>
                           <CustomNoData title="No purchased report data" description="No betting data found for the selected date range." />
                        </td>
                      </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    </Fragment>
  )
}

export default ReportByPurchased;



